@if (inited) {
<div>
    <sm-toolbar>
        <p-button [disabled]="!isChanged()" icon="fas fa-save" label="Speichern" (onClick)="save()">
        </p-button>
        <span class="ml-5">Gültig ab:</span>
        <p-select class="width300" id="validDate" [options]="validDates" [(ngModel)]="validDate" (onChange)="selectValidDate(validDate)">
        </p-select>
        <p-button icon="fas fa-plus" label="Neue Variante" (onClick)="addValidDate()">
        </p-button>
        @if (!variantIsEditable()) {
        <p-message class="ml-4" severity="warn">Varianten, die auch vergangene Wochen abdecken, sind nicht editierbar. Für Änderungen bitte eine neue Variante anlegen</p-message>
        }
    </sm-toolbar>
    <p-table class="p-datatable-gridlines full-height" [value]="cells">
        <ng-template pTemplate="header">
            <tr>
                <th>Stunde</th>
                @for (index of rowIndexes; track index) {
                <th [style.width]="(100 / rowIndexes.length) + '%'">{{weekDayNames[index]}}</th>
                }
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-index="rowIndex">
            <tr [pSelectableRow]="row">
                <td>{{index + 1}}</td>
                @for (index of rowIndexes; track index) {
                <td class="timetable-cell" [class.cell-free]="_Utils.isNoe(row[index]) && row[index] != '\xa0'" pEditableColumn>
                    @if (variantIsEditable()) {
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <p-select [class]="(row[index].useAlternating ? 'edit-2' : 'edit-1') + (row[index].isCourses(false) ? '-b' : '')" id="person" [options]="domainsGui" optionLabel="label" optionValue="value"
                                [(ngModel)]="row[index].domain">
                            </p-select>
                            @if (row[index].isCourses(false)) {
                            <button pButton type="button" class="p-button-rounded p-button-text mr-1" icon="fas fa-pencil" (click)="editCourses(row[index], false)">
                            </button>
                            }
                            @if (row[index].useAlternating) {
                            <p-select class="edit-2" id="person" [options]="domainsGui" optionLabel="label" optionValue="value" [(ngModel)]="row[index].domainWeekB">
                            </p-select>
                            }
                            @if (row[index].isCourses(true)) {
                            <button pButton type="button" class="p-button-rounded p-button-text mr-1" icon="fas fa-pencil" (click)="editCourses(row[index], true)">
                            </button>
                            }
                            <tag-button value="A/B" severity="info" [clickable]=true [active]="row[index].useAlternating" (onClick)="switchAb(row[index])"></tag-button>
                        </ng-template>
                        <ng-template pTemplate="output">
                            @if (!row[index].useAlternating) {
                            <div class="mouse-pointer width100p height100p timetable-cell2">
                                <span>{{row[index].getTitle(false)}}</span>
                            </div>
                            }
                            @if (row[index].useAlternating) {
                            <div class="mouse-pointer width100p height100p timetable-cell2">
                                <span class="width50p">
                                    <p-tag class="tag-a" value="A"></p-tag>
                                    <span>{{row[index].getTitle(false)}}</span>
                                </span>
                                <span class="width50p">
                                    <p-tag class="tag-b" value="B"></p-tag>
                                    <span>{{row[index].getTitle(true)}}</span>
                                </span>
                            </div>
                            }
                        </ng-template>
                    </p-cellEditor>
                    }
                    @if (!variantIsEditable()) {
                    @if (!row[index].useAlternating) {
                    <div class="width100p height100p timetable-cell2" [pTooltip]="row[index].courseNames">
                        <span>{{row[index].getTitle(false)}}</span>
                    </div>
                    }
                    @if (row[index].useAlternating) {
                    <div class="width100p height100p timetable-cell2" [pTooltip]="row[index].courseNames">
                        <span class="width50p">
                            <p-tag class="tag-a" value="A"></p-tag>
                            <span>{{row[index].getTitle(false)}}</span>
                        </span>
                        <span class="width50p">
                            <p-tag class="tag-b" value="B"></p-tag>
                            <span>{{row[index].getTitle(true)}}</span>
                        </span>
                    </div>
                    }
                    }
                </td>
                }
            </tr>
        </ng-template>
    </p-table>
</div>
}